import { Injectable } from '@angular/core';
import liff from '@line/liff';
import { LogService } from 'src/app/core/logger/logger_service';
import { ReferenceService } from 'src/app/services/reference.service';
import * as uuid from 'uuid';
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private isLoggedIn: boolean = false;
  // private liffId: string = 'YOUR_LIFF_ID';
  log_uuid = uuid.v4();
  referenceUUID: string | null = null;
  logger_text = `auth service line register [${this.log_uuid}]`
  constructor(
    private logger: LogService,
    private referenceService:ReferenceService
  ) {
    this.referenceUUID = this.referenceService.getReferenceUUID();
    this.logger_text = `auth service line register [${this.log_uuid}] referenceUUID:[${this.referenceUUID}]`
  }

  async initLiff(liffId): Promise<void> {
    try {
      this.logger.info(`${this.logger_text} initLiff start`)
      await liff.init({ liffId: liffId });
      if (!liff.isLoggedIn()) {
        this.logger.info(`${this.logger_text} initLiff login`)
        this.login();
      } else {
        this.logger.info(`${this.logger_text} initLiff login success`)
        this.isLoggedIn = true;
      }
    } catch (error) {
      this.logger.error(`${this.logger_text} initLiff error: ${error?.message}`)
      console.error('LIFF initialization failed:', error);
      this.logger.error(`${this.logger_text} initLiff logout and login`);
      liff.logout();
      this.login();
    }
  }

  login(): void {
    this.logger.info(`${this.logger_text} login url:${window?.location?.href}`);
    liff.login({ redirectUri: window?.location?.href });
  }

  logout(): void {
    this.logger.info(`${this.logger_text} logout`);
    liff.logout();
  }

  getLoginStatus(): boolean {
    this.logger.info(`${this.logger_text} getLoginStatus start`);
    const isLoggedIn = liff.isLoggedIn();
    if(isLoggedIn){
      this.logger.info(`${this.logger_text} getLoginStatus is true`)
      return true;
    }else{
      this.logger.info(`${this.logger_text} getLoginStatus is false`)
      return false;
    }    
  }

  getAccessToken(): string{
    this.logger.info(`${this.logger_text} getAccessToken isLoggedIn ${this.isLoggedIn}`)
    if(this.isLoggedIn){
      return liff.getAccessToken();
    }
    return "";
  }

  setChannelLineId(data):void {
    sessionStorage.setItem("channel_line_id",data);
  }
  getChannelLineId():string {
    return sessionStorage.getItem("channel_line_id");
  }
  setLiffChannelId(data):void {
    sessionStorage.setItem("liff_channel_id",data);
  }
  getLiffChannelId():string {
    return sessionStorage.getItem("liff_channel_id");
  }
}
